"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Mission() {
  const shouldReduceMotion = useReducedMotion();
  const fadeInVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };
  const imageVariants = {
    hidden: {
      opacity: 0,
      scale: shouldReduceMotion ? 1 : 0.98
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.7,
        ease: "easeOut"
      }
    }
  };
  return <section id="missionoverview" data-nav="light" className="w-full !bg-[rgba(0,0,0,1)] font-['Switzer',sans-serif] ![padding:100px_0px_96px_0px]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl font-['Switzer',sans-serif]">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-16">
          
          {/* Columna de Imagen */}
          <motion.div className="lg:col-span-6 relative overflow-hidden rounded-xl shadow-md bg-muted" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: "-50px"
        }} variants={imageVariants} style={{
          opacity: 0
        }}>
            <div className="relative aspect-[4/3] sm:aspect-[16/11] w-full overflow-hidden rounded-xl">
              <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/church_worship_gathering.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/church_worship_gathering.png-wvc-sizes" alt="Reunión de adoración y alabanza en comunidad" loading="lazy" decoding="async" className="h-full w-full object-cover object-center transition-transform duration-500 !text-[rgba(44,49,58,1)] !opacity-[1] !bg-[rgba(0,0,0,1)] hover:scale-105" src="https://acadcr.org/wp-content/uploads/2026/08/01.jpg" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent pointer-events-none" />
            </div>
          </motion.div>

          {/* Columna de Texto */}
          <motion.div className="lg:col-span-6 flex flex-col items-start justify-center font-['Switzer',sans-serif]" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: "-50px"
        }} variants={fadeInVariants} style={{
          opacity: 0
        }}>
            <h2 className="text-3xl font-normal tracking-tight mb-6 !text-[rgba(247,249,250,1)] sm:text-4xl md:text-4xl font-['Switzer',sans-serif]">
              Su mandato Nuestra misión
            </h2>

            <div className="space-y-4 text-muted-foreground text-base sm:text-lg leading-relaxed font-['Switzer',sans-serif]">
              <p className="!text-[rgba(243,244,246,1)] font-['Switzer',sans-serif] !text-justify">
                MM33 representa el esfuerzo colaborativo de las Asambleas de Dios
                Mundial para participar en la mayor obra de evangelismo,
                discipulado y plantación de iglesias que el mundo haya visto,
                impulsando la expansión del Reino a medida que más personas se
                encuentren con el Evangelio.
              </p>
              <p className="!text-[rgba(250,250,252,1)] font-['Switzer',sans-serif] !text-justify">
                La Gran Comisión es Su mandato y nuestra misión. Estamos buscando
                al Señor y dando pasos para crecer hasta un millón de iglesias
                para el 2000 aniversario de la resurrección de Jesucristo y el
                Día de Pentecostés en 2033, ¡y continuaremos con la misión!
              </p>
            </div>

            <div className="mt-8">
              <Button asChild size="lg" className="font-normal text-base px-8 py-3 rounded-md shadow-sm transition-all font-['Switzer',sans-serif]">
                <Link to="/MissionsPage" className="inline-flex items-center gap-2">
                  <span>Nuestra misión</span>
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </Button>
            </div>
          </motion.div>
          
        </div>
      </div>
    </section>;
}